import OwnersManagement from "src/modules/owners/OwnersManagement";

export default OwnersManagement;
